// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".line_m0AnyP {\n  z-index: 9999;\n  position: absolute;\n  background-color: #0057ff;\n}\n.xLine_VvOqGZ {\n  height: 2px;\n}\n.yLine_VmA5Zp {\n  width: 2px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/EditLine/Lines/index.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;AACF;AACA;EACE,WAAA;AACF;AAEA;EACE,UAAA;AAAF","sourcesContent":[".line {\n  z-index: 9999;\n  position: absolute;\n  background-color: rgba(0, 87, 255, 1); // #02dcf7;\n}\n.xLine {\n  height: 2px;\n}\n\n.yLine {\n  width: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"line": "line_m0AnyP",
	"xLine": "xLine_VvOqGZ",
	"yLine": "yLine_VmA5Zp"
};
export default ___CSS_LOADER_EXPORT___;
